import React from 'react';
import { useIntl } from 'react-intl';
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  AttachmentsResponse,
} from '../../../../../../../UILibrary';
import { definedTranslation } from '../../../i18n';

type FileSelectorProps = {
  selectedFileIndex: number | null;
  items?: AttachmentsResponse['items'];
  onChange: (value: string, label?: string | undefined) => void;
};

export function FileSelector({
  selectedFileIndex,
  items,
  onChange,
}: FileSelectorProps) {
  const intl = useIntl();

  return (
    <Select
      value={selectedFileIndex?.toString() ?? ''}
      onChange={onChange}
      direction="bottom-start"
      options={items?.map((file, idx) => ({
        value: idx.toString(),
        label: file.name,
      }))}
    >
      <SelectTrigger className="w-full flex sm:hidden">
        <SelectValue
          placeholder={intl?.formatMessage(
            definedTranslation.previewFiles.fileSelectorPlaceholder,
          )}
        />
      </SelectTrigger>
      <SelectContent>
        {items?.map((file, idx) => (
          <SelectItem key={file.name} value={idx.toString()}>
            {file.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
